import { mapActions } from "vuex";
import featureMixin from "./featureMixin";

export default {
  mixinName: "featureLoaderMixin",
  mixins: [featureMixin],
  watch: {
    storeFeatureLoadable(value) {
      if (value) {
        this.loadFeature();
      }
    },
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
      setFeaturesFilter: "features/setFeaturesFilter",
    }),
    showFeatureOrConsent({ scrollIntoView = false }) {
      if (this.storeFeatureLoadable) {
        this.loadFeature();
        if (scrollIntoView) {
          this.$el.parentNode.scrollIntoView({ behaviour: "smooth" });
        }
      } else {
        this.setFeaturesFilter(this.featureName);
        this.showModal("featureTable");
      }
    },
  },
};
